/* Claude QA 10-8: one-size products skip the size step.
   Any option with a single value (e.g. Size: One Size) is checked automatically and its tiles are hidden,
   so Add to Bag works straight away. Also runs for quick-add modals that inject variant pickers later. */
(function () {
  function fix(root) {
    (root || document).querySelectorAll('variant-options').forEach(function (picker) {
      if (picker.dataset.amSingleDone) return;
      picker.dataset.amSingleDone = '1';
      var toChange = null;
      picker.querySelectorAll('fieldset.product-form__input').forEach(function (fieldset) {
        var inputs = fieldset.querySelectorAll('input[type="radio"]');
        if (inputs.length !== 1) return;
        var option = fieldset.closest('.wt-product__option');
        if (option) option.classList.add('am-option--single');
        if (!inputs[0].checked) {
          inputs[0].checked = true;
          toChange = inputs[0];
        }
      });
      if (!toChange) return;
      var url = window.location.href;
      var isMainProduct = !picker.closest('quick-add, .quick-add-modal, .wt-quick-buy, [id*="QuickAdd"]');
      toChange.dispatchEvent(new Event('change', { bubbles: true }));
      // keep the product URL clean (the picker adds ?variant=)
      if (isMainProduct && url.indexOf('variant=') === -1) {
        setTimeout(function () {
          try { history.replaceState(history.state, '', url); } catch (e) {}
        }, 400);
      }
    });
  }

  function start() {
    fix(document);
    if (!('MutationObserver' in window)) return;
    var queued = false;
    new MutationObserver(function (mutations) {
      if (queued) return;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          queued = true;
          requestAnimationFrame(function () { queued = false; fix(document); });
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function boot() {
    // wait for the theme's <variant-options> element so the change event is heard
    if (window.customElements && customElements.whenDefined) customElements.whenDefined('variant-options').then(start);
    else start();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
